'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/9/16.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reduxForm = require('redux-form');

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _GoeasyRadio = require('../GoeasyInputField/GoeasyRadio');

var _GoeasyRadio2 = _interopRequireDefault(_GoeasyRadio);

var _GoeasyCheckboxField = require('../GoeasyInputField/GoeasyCheckboxField/GoeasyCheckboxField');

var _GoeasyCheckboxField2 = _interopRequireDefault(_GoeasyCheckboxField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvoiceInfoModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'invoiceInfoModal',
  fields: ['type', 'invoiceType', 'projectType', 'companyName', 'isDefault']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InvoiceInfoModal, _Component);

  function InvoiceInfoModal() {
    (0, _classCallCheck3.default)(this, InvoiceInfoModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(InvoiceInfoModal).call(this));

    _this.state = {
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(InvoiceInfoModal, [{
    key: 'onDefaultChange',
    value: function onDefaultChange(newValue) {
      var isDefault = this.props.fields.isDefault;

      if (isDefault.value !== newValue) {
        isDefault.onChange(newValue);
      }
    }
  }, {
    key: 'onFieldChange',
    value: function onFieldChange(val, field) {
      var _props$fields = this.props.fields;
      var type = _props$fields.type;
      var invoiceType = _props$fields.invoiceType;
      var projectType = _props$fields.projectType;

      if (field === 'type') {
        type.onChange(val);
      } else if (field === 'invoiceType') {
        invoiceType.onChange(val);
      } else if (field === 'projectType') {
        projectType.onChange(val);
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./InvoiceInfoModal.scss');
      var _props = this.props;
      var _props$fields2 = _props.fields;
      var type = _props$fields2.type;
      var invoiceType = _props$fields2.invoiceType;
      var projectType = _props$fields2.projectType;
      var companyName = _props$fields2.companyName;
      var isDefault = _props$fields2.isDefault;
      var listData = _props.listData;
      var operating = _props.operating;
      var errMessage = _props.errMessage;
      var handleSubmit = _props.handleSubmit;
      var closeHover = this.state.closeHover;

      var typeOptions = '';
      var invoiceTypeOptions = '';
      var projectTypeOptions = '';
      if (listData) {
        var typeList = listData.typeList;
        var invoiceTypeList = listData.invoiceTypeList;
        var projectTypeList = listData.projectTypeList;

        if (typeList instanceof Array) {
          typeOptions = typeList.map(function (currentType, index) {
            return _react2.default.createElement(_GoeasyRadio2.default, { key: index, currentData: currentType, Id: 'invoiceInfoModal_type' + index });
            // return <input key={index} type="radio" value={currentType.value}/>;
          });
        }
        if (invoiceTypeList instanceof Array) {
          invoiceTypeOptions = invoiceTypeList.map(function (currentInvoiceType, index) {
            return _react2.default.createElement(_GoeasyRadio2.default, { key: index, currentData: currentInvoiceType, Id: 'currentInvoiceType' + index });
          });
        }
        if (projectTypeList instanceof Array) {
          projectTypeOptions = projectTypeList.map(function (currentProjectType, index) {
            return _react2.default.createElement(_GoeasyRadio2.default, { key: index, currentData: currentProjectType, Id: 'currentProjectType' + index });
          });
        }
      }
      var _props2 = this.props;
      var onClose = _props2.onClose;
      var isOpened = _props2.isOpened;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          boxShadow: '3px 2px 20px',
          borderRadius: '30px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '600px',
          maxWidth: '60rem'
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.modalTitle },
          _react2.default.createElement('img', { className: closeHover ? styles.zhuan : styles.zhuan_a, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          { className: styles.component, onSubmit: handleSubmit },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '抬头类别：'
          ),
          _react2.default.createElement(
            _reactRadio2.default,
            { className: styles.radioGroup, value: type.value,
              name: 'invoiceInfoModal_type',
              onChange: function onChange(val) {
                return _this2.onFieldChange(val, 'type');
              } },
            typeOptions
          ),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '发票类型：'
          ),
          _react2.default.createElement(
            _reactRadio2.default,
            { className: styles.radioGroup, value: invoiceType.value,
              name: 'invoiceInfoModal_invoiceType',
              onChange: function onChange(val) {
                return _this2.onFieldChange(val, 'invoiceType');
              } },
            invoiceTypeOptions
          ),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '发票项目：'
          ),
          _react2.default.createElement(
            _reactRadio2.default,
            { className: styles.radioGroup, value: projectType.value,
              name: 'invoiceInfoModal_projectType',
              onChange: function onChange(val) {
                return _this2.onFieldChange(val, 'projectType');
              } },
            projectTypeOptions
          ),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '发票抬头：', inputType: 'textarea', fieldStyle: { width: '400px' }, formProps: companyName }),
          _react2.default.createElement(_GoeasyCheckboxField2.default, { label: '是否默认：', value: isDefault.value, onChange: this.onDefaultChange.bind(this) }),
          errMessage ? _react2.default.createElement(
            'span',
            { className: styles.error },
            errMessage
          ) : '',
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: operating ? 'none' : 'block', marginRight: '85px' }, btnClick: handleSubmit,
            text: '提交' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: operating ? 'none' : 'block', marginRight: '125px' }, btnClick: onClose,
            text: '关闭' })
        )
      );
    }
  }]);
  return InvoiceInfoModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  isOpened: _react.PropTypes.bool,
  data: _react.PropTypes.object,
  listData: _react.PropTypes.object,
  onClose: _react.PropTypes.func,
  onAddressChange: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  operating: _react.PropTypes.bool,
  errMessage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = InvoiceInfoModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InvoiceInfoModal/InvoiceInfoModal.js
 ** module id = 1360
 ** module chunks = 0
 **/